module.exports = __webpack_public_path__ + "img/unobtained.904549af.png";